import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { defer } from 'rxjs';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetOperatorStateType, IGetSelectorStateType } from '@cbridge-utils/reselect';
import { waitForIntervalData } from '../_operators/waitForIntervalData';
import { ScheduleIntervalAction } from '../scheduleInterval.action';
import { scheduleIntervalStoreSelector } from '../scheduleInterval.selector';

type IState =
  & IGetSelectorStateType<typeof scheduleIntervalStoreSelector>
  & IGetOperatorStateType<typeof waitForIntervalData>;

export const viewIntervalsEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleIntervalAction.viewIntervals),
  withLatestFrom(state$),
  mergeMap(([payload]) => {
    const { scheduleId } = payload;

    const afterCheck$ = defer(() => {
      return [];
    });

    return waitForIntervalData(
      scheduleId,
      state$,
      action$,
      {
        afterCheck$,
        alreadyCheck$: afterCheck$,
      },
    );
  }),
);
